export const SERVICES = [
  {
    slug: "deep-tissue-massage",
    path: "/services/deep-tissue-massage",
    name: "Deep Tissue Massage",
    tagline: "Grounded Pressure for Lasting Muscular Release",
    metaTitle: "Deep Tissue Massage in Kothapet, Hyderabad | Tira Spa",
    metaDescription:
      "Book a deep tissue massage at Tira Spa, Kothapet. Firm therapeutic pressure to melt chronic tension and knots. Call +91 90004 38800.",
    heroImage:
      "https://images.unsplash.com/photo-1660735698223-23a4edefa264?crop=entropy&cs=srgb&fm=jpg&q=85",
    cardImage:
      "https://images.unsplash.com/photo-1660735698223-23a4edefa264?crop=entropy&cs=srgb&fm=jpg&q=85",
    excerpt:
      "Firm, grounded pressure drawn from a heated stone ritual to dissolve the deepest layers of tension.",
    description:
      "An intensive therapy for guests carrying chronic tension, stiff shoulders or a nagging lower back ache. Our therapists use slow, deliberate strokes and sustained pressure — often paired with warm stones and steam — to reach deep muscle layers and release the adhesions that build up from long hours, intense training, or everyday stress.",
    benefits: [
      "Releases chronic muscular tension & stubborn knots",
      "Improves circulation to overworked muscle groups",
      "Breaks down scar tissue & fascia adhesions",
      "Eases lower back, neck & shoulder stiffness",
      "Restores mobility, flexibility & posture",
    ],
    process: [
      {
        title: "Grounded Welcome",
        text: "A quiet consultation on pressure points and preferred intensity.",
      },
      {
        title: "Warm Stone Glide",
        text: "Heated stones and steam prepare the muscles for deeper work.",
      },
      {
        title: "Deep Pressure Ritual",
        text: "Sustained, targeted pressure dissolves knots layer by layer.",
      },
      {
        title: "Still Closure",
        text: "A slow, grounding finish calms the nervous system before you rise.",
      },
    ],
    durations: ["60 min", "90 min", "120 min"],
  },
  {
    slug: "thai-massage",
    path: "/services/thai-massage",
    name: "Thai Massage",
    tagline: "Ancient Rhythmic Therapy for Energy & Flexibility",
    metaTitle: "Thai Massage in Kothapet, Hyderabad | Tira Spa",
    metaDescription:
      "Experience traditional Thai Massage at Tira Spa, Kothapet — assisted stretching & acupressure along the Sen lines. Call +91 90004 38800.",
    heroImage:
      "https://images.unsplash.com/photo-1544161558-d5fa96ee28c6?crop=entropy&cs=srgb&fm=jpg&q=85",
    cardImage:
      "https://images.unsplash.com/photo-1544161558-d5fa96ee28c6?crop=entropy&cs=srgb&fm=jpg&q=85",
    excerpt:
      "Rhythmic compression and gentle assisted stretching to realign the body's energy pathways.",
    description:
      "Rooted in centuries-old Thai healing tradition, this therapy blends rhythmic acupressure with assisted, yoga-like stretches performed along the body's Sen energy lines. Practised on a floor mat without oil, it coaxes stiff joints and tight muscles into a greater range of motion while settling an overworked mind into stillness.",
    benefits: [
      "Increases flexibility & joint range of motion",
      "Stimulates energy flow along Sen lines",
      "Relieves stiffness without the use of oils",
      "Calms the nervous system & quiets the mind",
      "Improves posture, balance & circulation",
    ],
    process: [
      {
        title: "Gentle Reading",
        text: "We check flexibility, injuries and comfort with assisted stretching.",
      },
      {
        title: "Acupressure Awakening",
        text: "Rhythmic palm & thumb pressure along the Sen lines awakens the body.",
      },
      {
        title: "Guided Stretch Flow",
        text: "Yoga-inspired stretches open the hips, spine and shoulders.",
      },
      {
        title: "Grounded Stillness",
        text: "Slow compressions bring the session to a calm, centred finish.",
      },
    ],
    durations: ["60 min", "90 min", "120 min"],
  },
  {
    slug: "full-body-massage",
    path: "/services/full-body-massage",
    name: "Full Body Massage",
    tagline: "A Comprehensive Head-to-Toe Revival",
    metaTitle: "Full Body Massage in Kothapet, Hyderabad | Tira Spa",
    metaDescription:
      "Unwind with a full body massage at Tira Spa, Kothapet — long flowing strokes from head to toe. Call +91 90004 38800 to book.",
    heroImage:
      "https://images.unsplash.com/photo-1712659604528-b179a3634560?crop=entropy&cs=srgb&fm=jpg&q=85",
    cardImage:
      "https://images.unsplash.com/photo-1712659604528-b179a3634560?crop=entropy&cs=srgb&fm=jpg&q=85",
    excerpt:
      "An immersive ritual that moves across the entire body in one continuous, grounded sequence.",
    description:
      "A signature Tira Spa ritual that treats the entire body — scalp, neck, back, arms, legs and feet — in one seamless, flowing sequence set within a warm, architectural sanctuary. Long gliding strokes are paired with careful kneading to melt away everyday fatigue, leaving every muscle softened and the mind completely unplugged.",
    benefits: [
      "Full-body stress & fatigue relief",
      "Improved circulation from head to toe",
      "Deep, sustained state of relaxation",
      "Supports better, deeper sleep",
      "Soothes tired feet, legs, back & shoulders",
    ],
    process: [
      {
        title: "Arrival Ritual",
        text: "A quiet welcome into a warm, earthy sanctuary to help you settle.",
      },
      {
        title: "Full Sequence Flow",
        text: "Flowing strokes move systematically from scalp to feet.",
      },
      {
        title: "Pressure Point Focus",
        text: "Extra attention on the back, shoulders and feet — the body's biggest stress holders.",
      },
      {
        title: "Quiet Return",
        text: "A few still minutes to rest before you step back into your day.",
      },
    ],
    durations: ["60 min", "90 min", "120 min"],
  },
  {
    slug: "aromatherapy-massage",
    path: "/services/aromatherapy-massage",
    name: "Aromatherapy Massage",
    tagline: "Botanical Rituals for Mind & Body Harmony",
    metaTitle: "Aromatherapy Massage in Kothapet, Hyderabad | Tira Spa",
    metaDescription:
      "Relax with an aromatherapy massage at Tira Spa using jade-infused botanical oils. Call +91 90004 38800 to book your ritual.",
    heroImage:
      "https://images.unsplash.com/photo-1581514439794-f9777f7c22eb?crop=entropy&cs=srgb&fm=jpg&q=85",
    cardImage:
      "https://images.unsplash.com/photo-1581514439794-f9777f7c22eb?crop=entropy&cs=srgb&fm=jpg&q=85",
    excerpt:
      "Therapeutic-grade botanical oils blended into a fragrant, calming massage ritual.",
    description:
      "A sensory-led therapy pairing gentle, flowing massage strokes with therapeutic-grade essential oils chosen for their calming, mood-balancing properties. As the fragrant blend is worked into the skin, tension dissolves and the mind settles into deep, earthy calm.",
    benefits: [
      "Reduces anxiety & mental fatigue",
      "Balances mood & emotional wellbeing",
      "Deeply nourishes & softens the skin",
      "Enhances the quality of sleep",
      "A soothing, fragrant sensory escape",
    ],
    oilsMenu: ["Eucalyptus", "Sandalwood", "Lavender", "Jade Clay"],
    process: [
      {
        title: "Scent Ritual Selection",
        text: "Choose from our curated oil blends based on your mood and needs.",
      },
      {
        title: "Warm Oil Massage",
        text: "Gentle, rhythmic strokes glide the warmed blend across the body.",
      },
      {
        title: "Breath & Stillness Pause",
        text: "Light pauses let the aroma settle, deepening relaxation.",
      },
      {
        title: "Fragrant Afterglow",
        text: "A calm, lingering sense of balance stays with you long after.",
      },
    ],
    durations: ["60 min", "90 min", "120 min"],
  },
];

export const getServiceBySlug = (slug) =>
  SERVICES.find((s) => s.slug === slug);
